import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const Footer = () => {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="text-2xl font-bold font-heading no-underline text-background-50">
                <span className="text-primary-400">韩漫</span>屋
              </Link>
              <p className="mt-4 text-sm text-background-400 leading-relaxed">
                韩国漫画和高质量漫画推荐平台，韩漫在线免费阅读。资源新颖，画质优良，是您漫画收藏的可靠平台。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
                漫画分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors no-underline"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors no-underline"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors no-underline"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors no-underline"
                  >
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
                关注我们
              </h4>
              <p className="text-sm text-background-400 mb-4 leading-relaxed">
                订阅Newsletter获取最新韩国漫画推荐资讯
              </p>
              <div className="flex gap-3">
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                  aria-label="Bilibili"
                  rel="nofollow"
                >
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2026 韩漫屋 HanManWu. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline" rel="nofollow">
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;